module.exports = __webpack_public_path__ + "static/7-a8d04af5280b1e2e3c3d599f863483e8.jpg";